import React, { useContext } from 'react';
import { ProductContext } from '../../ProductContext';
import { openStoreLocatorSidebar } from './storeLocatorSidebarState';
import { StoreLocatorType } from './storeLocatorTypes';
import { getCurrentLocation } from './storeLocatorUtils';
import { fireBOPISDataLayerEvent } from 'src/scripts/utils/gtm-data-layer';
import { BopisAnalyticsData } from '../Bopis/bopisTypes';

const StoreLocatorAction = ({
  storeLocatorType,
  analyticsEventDetails,
}: {
  storeLocatorType: StoreLocatorType;
  analyticsEventDetails?: BopisAnalyticsData;
}) => {
  const { sidebarPdpData } = useContext(ProductContext);
  const isSameDayDelivery = storeLocatorType === 'sdd';

  return (
    <div className="store-locator-action-container">
      <span
        className="store-locator-action"
        onClick={() =>
          openStoreLocatorSidebar({ feature: storeLocatorType, pdpProps: sidebarPdpData || undefined, page: 'pdp' })
        }
      >
        Search by zip
      </span>
      {isSameDayDelivery ? (
        <span>&nbsp;to check same day delivery availability</span>
      ) : (
        <span>
          &nbsp;to check pickup availability (or&nbsp;
          <span
            className="store-locator-action"
            onClick={() => {
              getCurrentLocation();
              if (analyticsEventDetails) {
                fireBOPISDataLayerEvent({
                  ...analyticsEventDetails,
                  eventName: 'bopis_customer_location_retrieval_event',
                });
              }
            }}
          >
            use my current location
          </span>
          )
        </span>
      )}
    </div>
  );
};

export { StoreLocatorAction };
